import '@mrhenry/wp--bugsnag-config';
import './modules/mr-navigation-overlay';
import './modules/mr-menu';

import { MrCarousel, MrInputSink } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-carousel', MrCarousel );
customElements.define( 'mr-input-sink', MrInputSink );
